import { useState } from "react";

import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    Typography,
    TableRow,
    Paper,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    TextField,
} from "@mui/material";
import { parseExcelPaste } from "../utils/parseExcelPaste";
import { API_URL } from "../config/api";

type Props = {
    open: boolean;
    onClose: () => void;
    onImported: (emailsSent: number, total: number) => void;
};

export default function ExcelImportDialog({
    open,
    onClose,
    onImported,
}: Props) {
    const [content, setContent] = useState("");
    const [preview, setPreview] = useState<any[]>([]);
    // const [existingJudokas, setExistingJudokas] = useState<any[]>([]);

    const loadExistingJudokas = async () => {

        const registrationCode =
            localStorage.getItem(
                "registrationCode"
            );

        if (!registrationCode) {
            return [];
        }

        const response = await fetch(
            `${API_URL}/registration/${registrationCode}`
        );

        const data = await response.json();

        return data.judokas ?? [];
    };

    const validateJudoka = (judoka: any, existingJudokas: any[]) => {
        const errors: string[] = [];
        const warnings: string[] = [];

        const alreadyExists =
            existingJudokas.some(
                (j) => j.licence === judoka.licence
            );

        if (alreadyExists) {
            warnings.push(
                "Déjà inscrit"
            );
        }

        if (!judoka.email)
            errors.push("Email manquant");

        if (!judoka.licence)
            errors.push("Licence manquante");

        if (!/^\d{6}$/.test(judoka.licence))
            errors.push("Licence invalide");

        if (!judoka.lastName)
            errors.push("Nom manquant");

        if (!judoka.firstName)
            errors.push("Prénom manquant");

        if (!judoka.birthDate)
            errors.push("Date naissance manquante");

        if (!judoka.clubNumber)
            errors.push("N° club manquant");

        if (!judoka.clubName)
            errors.push("Nom club manquant");

        return {
            ...judoka,
            errors,
            warnings,
        };
    };

    const rowsToImport =
        preview.filter(
            (p) =>
                p.errors.length === 0 &&
                p.warnings.length === 0
        );

    const handleClose = () => {
        setContent("");
        setPreview([]);

        onClose();
    };
    const importJudokas = async () => {

        const registrationCode =
            localStorage.getItem(
                "registrationCode"
            );

        if (!registrationCode) {
            return;
        }

        const response = await fetch(
            `${API_URL}/registration/${registrationCode}/judokas/import`,
            {
                method: "POST",
                headers: {
                    "Content-Type":
                        "application/json",
                },
                body: JSON.stringify({
                    judokas: rowsToImport.map((judoka) => ({
                        email: judoka.email,
                        licence: judoka.licence,
                        firstName: judoka.firstName,
                        lastName: judoka.lastName,
                        gender: judoka.gender,
                        nationality: judoka.nationality,
                        birthDate: judoka.birthDate,
                        category: judoka.category,
                        clubNumber: judoka.clubNumber,
                        clubName: judoka.clubName,
                    })),
                }),
            }
        );

        const created = await response.json();
        const emailsSent = created.filter(
            (j: any) => j.emailSent
        ).length;

        onImported(emailsSent, created.length);
        handleClose();
    };

    const generatePreview = async () => {

        const existing =
            await loadExistingJudokas();

        const parsed =
            parseExcelPaste(content);

        const validated = parsed.map(
            (j) =>
                validateJudoka(
                    j,
                    existing
                )
        );
        setPreview(validated);
    };

    const validRows = preview.filter(
        (p) => p.errors.length === 0
    ).length;

    const invalidRows = preview.filter(
        (p) => p.errors.length > 0
    ).length;

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            maxWidth="lg"
            fullWidth
        >
            <DialogTitle>
                Import Excel
            </DialogTitle>

            <DialogContent>

                <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{ mt: 2 }}
                >
                    Téléchargez le modèle CSV, complétez-le dans Excel,
                    puis copiez les lignes complétées (avec ou sans la ligne d'en-tête) et collez-les dans
                    la zone ci-dessus.
                </Typography>
                <Button
                    component="a"
                    href="/templates/template_judokas.csv"
                    download
                    variant="outlined"
                    sx={{ mb: 2 }}
                >
                    Télécharger le modèle CSV
                </Button>
                {/* <Button
                component="akas.csv">
                Télécharger le modèle
            </Button> */}


                {/* {preview.length === 0 && (
                )
                } */}
                <TableContainer
                    component={Paper}
                    sx={{ mt: 2 }}
                >
                    <Table size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell>Email</TableCell>
                                <TableCell>Licence</TableCell>
                                <TableCell>Nom</TableCell>
                                <TableCell>Prénom</TableCell>
                                <TableCell>Sexe</TableCell>
                                <TableCell>Nationalité</TableCell>
                                <TableCell>Date naissance</TableCell>
                                <TableCell>Catégorie</TableCell>
                                <TableCell>N° Club</TableCell>
                                <TableCell>Nom Club</TableCell>
                            </TableRow>
                        </TableHead>

                        <TableBody>
                            <TableRow>
                                <TableCell>email@domaine.be</TableCell>
                                <TableCell>123456</TableCell>
                                <TableCell>Dupont</TableCell>
                                <TableCell>Lucas</TableCell>
                                <TableCell>M</TableCell>
                                <TableCell>BEL</TableCell>
                                <TableCell>2014-01-31</TableCell>
                                <TableCell>U13</TableCell>
                                <TableCell>9001</TableCell>
                                <TableCell>J.C.SAMBREVILLE</TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </TableContainer>

                <TextField
                    multiline
                    minRows={10}
                    fullWidth
                    sx={{ mt: 3 }}
                    placeholder="Collez ici les données copiées depuis Excel"
                    label="Données Excel"
                    slotProps={{
                        inputLabel: {
                            shrink: true,
                        },
                    }}
                    value={content}
                    onChange={(e) =>
                        setContent(e.target.value)
                    }
                />

            </DialogContent>

            {
                preview.length > 0 && (
                    <>
                        <Paper
                            sx={{
                                p: 2,
                                mt: 2,
                                mb: 2,
                            }}
                        >
                            <strong>
                                {preview.length} ligne(s) analysée(s)
                            </strong>

                            <div>
                                ✅ {validRows} valide(s)
                            </div>

                            <div>
                                ❌ {invalidRows} invalide(s)
                            </div>
                        </Paper>

                        <TableContainer
                            component={Paper}
                            sx={{ mt: 3 }}
                        >
                            <Table size="small">

                                <TableHead>
                                    <TableRow>
                                        <TableCell>Licence</TableCell>
                                        <TableCell>Nom</TableCell>
                                        <TableCell>Prénom</TableCell>
                                        <TableCell>Sexe</TableCell>
                                        <TableCell>Catégorie</TableCell>
                                        <TableCell>Club</TableCell>
                                        <TableCell>Validation</TableCell>
                                        <TableCell>Statut</TableCell>
                                    </TableRow>
                                </TableHead>

                                <TableBody>
                                    {preview.map((judoka, index) => (
                                        <TableRow
                                            key={index}
                                            sx={{
                                                bgcolor:
                                                    judoka.errors.length > 0
                                                        ? "#ffebee"
                                                        : undefined,
                                            }}
                                        >
                                            <TableCell>
                                                {judoka.licence}
                                            </TableCell>

                                            <TableCell>
                                                {judoka.lastName}
                                            </TableCell>

                                            <TableCell>
                                                {judoka.firstName}
                                            </TableCell>

                                            <TableCell>
                                                {judoka.gender}
                                            </TableCell>

                                            <TableCell>
                                                {judoka.category}
                                            </TableCell>

                                            <TableCell>
                                                {judoka.clubName}
                                            </TableCell>

                                            <TableCell>
                                                {judoka.errors.length === 0
                                                    ? "✅ OK"
                                                    : judoka.errors.join(", ")
                                                }
                                            </TableCell>
                                            <TableCell>
                                                {judoka.errors.length > 0
                                                    ? judoka.errors.join(", ")
                                                    : judoka.warnings.length > 0
                                                        ? "⚠ " +
                                                        judoka.warnings.join(", ")
                                                        : "✅ OK"}
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>

                            </Table>
                        </TableContainer>
                    </>
                )
            }

            <DialogActions>
                <Button onClick={handleClose}>
                    Annuler
                </Button>
                <Button
                    variant="contained"
                    color="error"
                    onClick={generatePreview}
                >
                    {preview.length === 0
                        ? "Prévisualiser"
                        : "Rafraîchir la prévisualisation"}
                </Button>
                <Button
                    variant="contained"
                    color="success"
                    disabled={
                        preview.filter(
                            (p) =>
                                p.errors.length === 0 &&
                                p.warnings.length === 0
                        ).length === 0
                    }
                    onClick={importJudokas}
                >
                    Importer (
                    {
                        preview.filter(
                            (p) =>
                                p.errors.length === 0 &&
                                p.warnings.length === 0
                        ).length
                    }
                    )
                </Button>
            </DialogActions>
        </Dialog >
    );
}